import { FileRoot } from "./FileRoot";

export const File = {
  Root: FileRoot,
};
